// 活动页api
import axios from '@/utils/axios'

// 免单卡领取活动
export function FreeCardActivityGain (data) {
  return axios({
    url: '/SaleV2/FreeCard/FreeCardActivityGain',
    method: 'post',
    data: data
  })
}
